// const { mounted } = require("./GeneralBookingSettingMixin");

const BookingAcceptedTermsMixin = {
	computed: {
        bookingState : function() {
            return this.$store.getters.GET_BOOKING_STATE;
        },
		displayEndTerms: function() {
            if (!this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) {
                var bookingState = this.bookingState;
                if(bookingState.hasEndTerms && bookingState.selectedService) {
                    if(bookingState.selectedService.is_paid && bookingState.selectedService.is_paid == 1) {
                        return true;
                    } else{ 
                        return false;
                    }
                }
            } else {
                if (this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_ACCEPTED_BOOKING_TERMS.some(term => term.hasEndTerms && term.hasEndTerms === 'yes')) {
                    return this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS.some(product => product.isPaid) ? false : true;
                }
            }
        },
	},
    watch: {
        'acceptedTerms': function(v) {
            this.$store.dispatch("setBookingState", { acceptedTerms: !!v });
            if (!this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) return;
            const service_group_id = this.$store.getters.GET_ACTIVE_SERVICE_GROUP.service_group_id;
            const localBookingState = this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_ACCEPTED_BOOKING_TERMS.find(term => term.service_group_id == service_group_id) || {};
            this.$store.dispatch('setActiveMultipleServiceBookingTerms', {
                ...localBookingState,
                acceptedTerms: !!v
            });
        },
        'acceptedTerms2': function(v) {
            this.$store.dispatch("setBookingState", { acceptedTerms2: !!v });
            if (!this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) return;
            const service_group_id = this.$store.getters.GET_ACTIVE_SERVICE_GROUP.service_group_id;
            const localBookingState = this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_ACCEPTED_BOOKING_TERMS.find(term => term.service_group_id == service_group_id) || {};
            this.$store.dispatch('setActiveMultipleServiceBookingTerms', {
                ...localBookingState,
                acceptedTerms2: !!v
            });
        },
        'acceptedTerms3': function(v) {
            this.$store.dispatch("setBookingState", { acceptedTerms3: !!v });
            if (!this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) return;
            const service_group_id = this.$store.getters.GET_ACTIVE_SERVICE_GROUP.service_group_id;
            const localBookingState = this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_ACCEPTED_BOOKING_TERMS.find(term => term.service_group_id == service_group_id) || {};
            this.$store.dispatch('setActiveMultipleServiceBookingTerms', {
                ...localBookingState,
                acceptedTerms2: !!v
            });
        },
    },
};

module.exports = BookingAcceptedTermsMixin;